<!--
  ~ Copyright (c) 2020. Jellybean B.V. Apeldoorn
  ~ Jellybean B.V. Apeldoorn heeft een licentie verleend aan
  ~ Spin in het Web B.V. Apeldoorn voor het gebruik van deze software-
  ~ onderdelen in projecten voor derden. U heeft géén toestemming
  ~ tot inzage of wijziging in de (bron)code van deze onderdelen.
  -->
<div class="sihwdatatable_container" #container (scroll)="containerScroll($event)">
  <table class="sihwdatatable table" #table>
    <thead [ngStyle]="{transform: headersTransform ? 'translateY(' + headersTransform + 'px)' : '' }">
    <!-- groepen -->
    <tr *ngIf="t.groepen" class="datatable_groepen">
      <th *ngIf="t.kies && t.kies.links"></th>
      <th *ngIf="t.selecteer"></th>
      <th *ngFor="let groep of t.groepen" [class.ingroep]="groep" [attr.colspan]="groep ? groep.cols : 1">{{groep ? groep.label : ''}}</th>
      <th *ngIf="t.kies && t.kies.rechts"></th>
    </tr>
    <!-- koppen -->
    <tr class="datatable_koppen">
      <th *ngIf="t.kies && t.kies.links" class="datatable_kies">{{t.kies.label}}</th>
      <th *ngIf="t.selecteer" class="datatable_selecteer">{{t.selecteer.label}}</th>
      <ng-container *ngFor="let veld of t.velden">
        <th *ngIf="! veld.hide"
            [ngClass]="veld.kopclasses"><span
          *ngIf="veld.label" (click)="doesorteer(veld)">{{veld.label}}<span
          [hidden]="veld.sortering !== 1"> &#x25b2;</span><span [hidden]="veld.sortering !== -1"> &#x25bc;</span>
    </span></th>
      </ng-container>
      <th *ngIf="t.kies && t.kies.rechts" class="datatable_kies">{{t.kies.label}}</th>
    </tr>
    <tr *ngIf="t.toonfilter" class="datatable_filter">
      <td *ngIf="t.kies && t.kies.links" class="datatable_kies"></td>
      <td *ngIf="t.selecteer" class="datatable_selecteer">
        <button class="btn btn-outline-primary datatable_selecteeralles" (click)="selecteerAlles()"><span class="fas"
                                                                                  [ngClass]="{ 'fa-times': t.allesGeselecteerd, 'fa-check': ! t.allesGeselecteerd}"></span>
        </button>
      </td>
      <ng-container *ngFor="let veld of t.velden">
        <td [ngClass]="veld.filterclasses" *ngIf="! veld.hide">
          <div *ngIf="veld.filtertype === 'vrij'"
               class="form-group datatable_filter_vrij">
            <input title="{{veld.label || ''}}" type="text"
                   [(ngModel)]="t.filter[veld.key]"
                   (ngModelChange)="filterInputChange()"
                   autocomplete="off"
                   class="form-control">
          </div>
          <div *ngIf="veld.filtertype === 'bool'"
               class="form-group datatable_filter_bool"
               (click)="boolfilter_switch(veld)">
            <div class="form-control"><span title="{{veld.label || ''}}" class="fas"
                                            [class.datatable_bool_ja]="t.filter[veld.key] === 1"
                                            [class.fa-check]="t.filter[veld.key] === 1"
                                            [class.datatable_bool_nee]="t.filter[veld.key] === 2"
                                            [class.fa-times]="t.filter[veld.key] === 2"
                                            [class.datatable_bool_onbepaald]="! t.filter[veld.key]"
                                            [class.fa-ellipsis-h]="! t.filter[veld.key]"
            ></span></div>
          </div>
          <div *ngIf="veld.filtertype === 'enum'"
               class="form-group datatable_filter_enum">
            <select title="{{veld.label || ''}}" class="form-control form-select"
                    [name]="'filter_' + veld.key"
                    [(ngModel)]="t.filter[veld.key]"
                    autocomplete="off"
                    (ngModelChange)="filterInputChange(false)">
              <option [ngValue]="null"></option>
              <option *ngFor="let item of veld.filteropties" [ngValue]="item">
                {{item}}
              </option>
            </select>
          </div>
        </td>
      </ng-container>
      <td *ngIf="t.kies && t.kies.rechts" class="datatable_kies">&nbsp;</td>
    </tr>
    </thead>
    <tbody class="datatable_tbody">
    <tr class="datatable_data" *ngFor="let rij of t.data; trackBy: t.trackRij" (click)="doerijklik(rij)"
        [hidden]="! rij.infilter" [title]="rij.rijtitle"
        [ngClass]="rij.rijclasses" [class.datatable-oneven]="! rij.stripe" [class.datatable-even]="rij.stripe">
      <td *ngIf="t.kies && t.kies.links" class="datatable_kies"><a *ngIf="rij.kiesbaar"
                                                                   [class]="t.kies.class"
                                                                   (click)="kiesClick(rij)"
                                                                   [innerHTML]="t.kies.content.links || t.kies.content"></a>
      </td>
      <td *ngIf="t.selecteer" class="datatable_selecteer" (click)="selectClick(rij,true, $event)">
        <ng-container *ngIf="rij.selecteerbaar"><input type="checkbox" (ngModelChange)="selectClick(rij,false)"
                                                       [(ngModel)]="rij.geselecteerd"></ng-container>
      </td>
      <ng-container *ngFor="let veld of t.velden">
        <ng-container *ngIf="! veld.hide" [ngSwitch]="veld.type">
          <ng-container *ngSwitchCase="'actie'">
            <td [ngClass]="veld.tdclasses" [style]="rij.style[veld.key]">
              <span [ngClass]="rij.classes[veld.key]" (click)="veld.typeArgs?.click && veld.typeArgs.click(rij.data)"
                    [innerHTML]="veld.typeArgs.html || ''"></span>
            </td>
          </ng-container>
          <ng-container *ngSwitchDefault>
            <td [ngClass]="veld.tdclasses" [style]="rij.style[veld.key]" *ngIf="! veld.hide">
        <span *ngIf="veld.html" [ngClass]="rij.classes[veld.key]"
              [innerHTML]="rij.format_html[veld.key]"></span>
              <span *ngIf="! veld.html" [ngClass]="rij.classes[veld.key]" [innerText]="rij.format[veld.key]"></span>
            </td>
          </ng-container>
        </ng-container>
      </ng-container>
      <td *ngIf="t.kies && t.kies.rechts" class="datatable_kies"><a *ngIf="rij.kiesbaar" [class]="t.kies.class"
                                                                    (click)="kiesClick(rij)"
                                                                    [innerHTML]="t.kies.content.rechts || t.kies.content"></a>
      </td>
    </tr>
    </tbody>
  </table>
</div>
